import { ColumnEnum } from '@/enums';

export const getSoldTableColumnOrder = () => [
  ColumnEnum.street,
  ColumnEnum.contractDate,
  ColumnEnum.soldPrice,
  ColumnEnum.livingArea,
  ColumnEnum.rooms,
  ColumnEnum.floorFloors,
  ColumnEnum.constructionYear,
  ColumnEnum.plotArea,
  ColumnEnum.ancillaryArea,
  ColumnEnum.soldPriceSqm,
  ColumnEnum.recountedPrice,
  ColumnEnum.recountedPriceSqm,
  ColumnEnum.taxasionValue,
  ColumnEnum.taxationYear,
  ColumnEnum.priceTaxationRatio,
  ColumnEnum.monthlyFee,
  ColumnEnum.ownSale,
  ColumnEnum.monthlyFeeSqm,
  ColumnEnum.source,
  ColumnEnum.adRegisteredDate,
  ColumnEnum.adDeleteDate,
  ColumnEnum.adAdvertisingDays,
  ColumnEnum.adPrice,
  ColumnEnum.adPriceSqm,
  ColumnEnum.firm,
  ColumnEnum.prospectUrl,
  ColumnEnum.propertyUnitDesignation,
  ColumnEnum.valuationYear,
  ColumnEnum.homeType,
  ColumnEnum.ownershipType,
  ColumnEnum.housingAssociationReportYear,
  ColumnEnum.ownerName,
  ColumnEnum.ownerId,
  ColumnEnum.allabrfUrl,
  ColumnEnum.allabolagUrl,
  ColumnEnum.shoreDistanceType,
  ColumnEnum.waterSewerageType,
  ColumnEnum.alterationYear,
  ColumnEnum.standardPoints,
  ColumnEnum.leaseholdFee,
  ColumnEnum.leaseholdPeriod,
  ColumnEnum.subdivisionType,
  ColumnEnum.balcony,
  ColumnEnum.elevator,
];

export const getAdsTableColumnOrder = () => [
  ColumnEnum.street,
  ColumnEnum.registeredDate,
  ColumnEnum.advertisingDays,
  ColumnEnum.constructionYear,
  ColumnEnum.livingArea,
  ColumnEnum.rooms,
  ColumnEnum.floorFloors,
  ColumnEnum.plotArea,
  ColumnEnum.ancillaryArea,
  ColumnEnum.price,
  ColumnEnum.priceSqm,
  ColumnEnum.monthlyFee,
  ColumnEnum.homeType,
  ColumnEnum.ownershipType,
  ColumnEnum.firm,
  ColumnEnum.pdf,
];